<template>
  <!-- <v-divider class="mt-n2 mx-0"> </v-divider> -->
  <div>
    <v-card
      v-if="
        checkaccessdata.is_viewer == false && checkaccessdata.is_maker == false
      "
      class="mt-16"
      flat
    >
      <v-row justify="center" align="center">
        <v-card-title class="red--text"><h2>Access Denied</h2></v-card-title>
      </v-row>
      <v-row justify="center" align="center">
        <v-card-subtitle class="subtitle-1"
          >You do not have Permission to access.</v-card-subtitle
        >
      </v-row>
    </v-card>
    <v-card class="mt-6 elevation-4 ma-2" v-else>
      <v-row class="mb-4">
        <v-card-title class="ml-4 primary--text"
          ><v-btn @click="back" class="ml-n7 primary--text" text>
            <v-icon>mdi-reply</v-icon></v-btn
          >
          Department
          <span
            style="
              font-style: italic;
              font-family: Times New Roman;
              font-size: 14px;
            "
            class="text-left font-weight: 20 primary--text ml-2"
            >(Settings To Create Different Departments)</span
          >
        </v-card-title>
        <v-spacer></v-spacer>

        <v-col cols="12" sm="12" xl="3" xs="12" lg="3" md="3">
          <v-text-field
            v-model="search"
            shaped
            outlined
            dense
            class="mt-1 ml-2 mr-2"
            color="primary"
            append-icon="mdi-magnify"
            label="Search"
            hide-details
          ></v-text-field
        ></v-col>
        <v-col cols="12" sm="12" xl="2" xs="12" lg="2" md="2">
          <v-btn
            class="navbar white--text elevation-0 mt-1"
            dense
            rounded
            @click="AddDepartment = true"
          >
            <v-icon>mdi-plus</v-icon>Add
          </v-btn>
        </v-col>
      </v-row>

      <v-data-table
        dense
        :headers="headers"
        :items="getdepartmentlist"
        :search="search"
        :no-data-text="Nodata"
      >
        <template v-slot:[`item.sl_no`]="{ item }">
          <span class="caption">{{ getdepartmentlist.indexOf(item) + 1 }}</span>
        </template>
        <template v-slot:[`item.department_name`]="{ item }">
          <span class="caption">{{ item.department_name }}</span>
        </template>
        <template v-slot:[`item.department_description`]="{ item }">
          <span class="caption">{{ item.department_description }}</span>
        </template>
        <template v-slot:[`item.created_on`]="{ item }">
          <span class="caption">{{ item.created_on }}</span>
        </template>
        <template v-slot:[`item.action`]="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn icon x-small v-on="on" color="primary">
                <v-icon @click="Edit(item)" small>mdi-pencil</v-icon>
              </v-btn>
            </template>
            <span>View details</span>
          </v-tooltip>
        </template>
        <!-- <template v-slot:top>
          <v-layout row wrap class="mb-2">
            <v-row>
              <v-col lg="6">
                <v-card-title class="ml-2 primary--text">
                  Department
                </v-card-title>
              </v-col>
              <v-spacer />
              <v-col lg="4" class="mt-4">
                <v-text-field
                  v-model="search"
                  shaped
                  outlined
                  dense
                  class="mt-n1 ml-8"
                  color="primary"
                  append-icon="mdi-magnify"
                  label="Search"
                  hide-details
                ></v-text-field>
              </v-col>
              <v-col lg="2" class="mt-3">
                <v-btn
                  class="primary white--text"
                  rounded
                  @click="AddDepartment = true"
                >
                  <v-icon>mdi-plus</v-icon>Add
                </v-btn>
              </v-col>
            </v-row>
          </v-layout>
        </template> -->
      </v-data-table>
      <v-dialog persistent v-model="AddDepartment" width="600">
        <v-toolbar dark dense class="header">
          <v-icon>mdi-plus</v-icon>
          <span class="ml-3">Add Department</span>
          <v-spacer></v-spacer>

          <v-btn class text dark @click="closedialog">
            <v-icon color="white" small>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>

        <v-card>
          <v-divider></v-divider>
          <v-form ref="formDept">
            <v-row class="mt-8 mx-7">
              <v-text-field
                v-model="Name"
                label="Department Name *"
                color="primary"
                :rules="[(v) => !!v || 'Required']"
                required
                outlined
                dense
                maxlength="85"
                @keydown.space="preventLeadingSpace"
              ></v-text-field>
            </v-row>
            <v-row class="mx-7">
              <v-textarea
                v-model="Description"
                color="primary"
                :rules="[(v) => !!v || 'Required']"
                rows="1"
                auto-grow
                maxlength="100"
                label="Description *"
                required
                outlined
                counter
                dense
                @keydown.space="preventLeadingSpace"
              ></v-textarea>
            </v-row>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                rounded
                class="primary white--text mr-2 mt-3"
                :loading="isLoading"
                medium
                @click="createDepartment"
              >
                Add
              </v-btn>
            </v-card-actions>
          </v-form>
        </v-card>
      </v-dialog>
      <v-dialog persistent v-model="EditDepartment" width="600">
        <v-toolbar dark dense class="header">
          <v-icon>mdi-pencil</v-icon>
          <span class="ml-3">Edit Department</span>
          <v-spacer></v-spacer>

          <v-btn class text dark @click="closedialogNew">
            <v-icon color="white" small>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>

        <v-card>
          <v-divider></v-divider>
          <v-form ref="form">
            <v-row class="mt-8 mx-7">
              <v-text-field
                v-model="EditName"
                label="Department Name *"
                color="primary"
                :rules="[(v) => !!v || 'Required']"
                required
                outlined
                dense
                maxlength="85"
                @keydown.space="preventLeadingSpace"
              ></v-text-field>
            </v-row>
            <v-row class="mx-7">
              <v-textarea
                v-model="EditDescr"
                color="primary"
                :rules="[(v) => !!v || 'Required']"
                rows="1"
                auto-grow
                maxlength="100"
                label="Description *"
                required
                outlined
                counter
                dense
                @keydown.space="preventLeadingSpace"
              ></v-textarea>
            </v-row>
          </v-form>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              rounded
              class="primary white--text mr-2 mt-5"
              :loading="isLoading"
              medium
              @click="Editdepartment"
            >
              Update
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-card>
    <OverleyProccessg :overlay="overlay" />
  </div>
</template>

<script>
import OverleyProccessg from "@/Views/OverleyProccessg.vue";
import { apiCall } from "@/Views/APICALL/APIcall.js";

export default {
  components: {
    OverleyProccessg,
  },
  data: () => ({
    checkaccessdata: {},

    overlay: false,
    search: "",
    isLoading: false,
    AddDepartment: false,
    Name: "",
    nameRules: [(v) => !!v || "Required"],
    Description: "",
    getdepartmentlist: [],
    headers: [
      { text: "SL NO", value: "sl_no" },
      {
        text: "DEPARTMENT NAME",
        value: "department_name",
      },
      {
        text: "DESCRIPTION",
        value: "department_description",
      },
      {
        text: "CREATED ON",
        value: "created_on",
      },
      {
        text: "ACTION",
        value: "action",
      },
    ],
    EditDepartment: false,
    EditName: "",
    EditDescr: "",
    DeptId: "",
    Nodata: "",
  }),
  created() {
    if (this.$store.getters.get_dialogcheck == true) {
      this.AddDepartment = true;
    }
  },
  mounted() {
    this.getdepartment();
    this.checkaccess();
  },
  methods: {
    async checkaccess() {
      var inputData = {
        method_name: "ACCESS",
        page_no: 0,
        record_count: 0,
        page_size: 25,
        app_code: "CPORTAL",
        method_param: {
          action: "CHECK_ACCESS",
          user_id: this.$store.getters.get_userid,
          module_code: "SETTINGS",
          module_type: "2",
        },
      };
      var responseData = await apiCall(inputData);

      this.checkaccessdata = responseData.data.data;
      // console.log("checkaccessdata", this.checkaccessdata);
    },
    back() {
      this.$router.push("/Timeline");
    },
    async createDepartment() {
      if (this.$refs.formDept.validate()) {
        this.isLoading = true;
        var inputData = {
          method_name: "CORPONBOARD",
          page_no: 0,
          record_count: 0,
          page_size: 25,
          app_code: "CPORTAL",
          method_param: {
            action: "DEPMASTER",
            department_id: 0,
            department_name: this.Name,
            department_description: this.Description,
            corp_id: this.$store.getters.get_corpid,
          },
        };
        var responseData = await apiCall(inputData);
        this.deplist = responseData;
        if (responseData.data.status == "00") {
          this.$store.commit("snackbar/showMessage", {
            content: responseData.data.status_msg,
            color: "green",
          });
          this.getdepartment();
          this.getuserdeatils();
          this.$refs.formDept.reset();

          this.AddDepartment = false;
          this.isLoading = false;
        } else {
          this.$store.commit("snackbar/showMessage", {
            content: responseData.data.status_msg,
            color: "red",
          });
          this.isLoading = false;
          this.AddDepartment = false;
        }
      }
    },
    async Editdepartment() {
      if (this.$refs.form.validate()) {
        var inputData = {
          method_name: "CORPONBOARD",
          page_no: 0,
          record_count: 0,
          page_size: 25,
          app_code: "CPORTAL",
          method_param: {
            action: "DEPMASTER",
            department_id: this.DeptId,
            department_name: this.EditName,
            department_description: this.EditDescr,
            corp_id: this.$store.getters.get_corpid,
          },
        };
        var responseData = await apiCall(inputData);
        this.deplist = responseData;
        if (responseData.data.status == "00") {
          this.$store.commit("snackbar/showMessage", {
            content: responseData.data.status_msg,
            color: "green",
          });
          this.getdepartment();

          this.EditDepartment = false;
        } else {
          this.$store.commit("snackbar/showMessage", {
            content: responseData.data.status_msg,
            color: "red",
          });

          this.EditDepartment = false;
        }
      }
    },

    async getuserdeatils() {
      // alert(20);
      var inputData = {
        method_name: "CORPONBOARD",
        page_no: 0,
        record_count: 0,
        page_size: 25,
        app_code: "CPORTAL",
        method_param: {
          action: "CORPLOGIN",
          email_id: this.$store.getters.get_useremail,
        },
      };
      var responseData = await apiCall(inputData);
      if (responseData.data.status == "00") {
        if (responseData.data.data != null || responseData.data.data != "") {
          var rowlist = responseData.data.data;
          this.$store.commit("SET_Cusdetails", rowlist);
        }
        // rowlist.department_count = "1";
        if (rowlist.department_count == "1") {
          this.$router.push("/Dashboard");
        }
      }
      //console.log("getuserdeatils", responseData);
    },
    closedialog() {
      this.$refs.formDept.reset();
      this.AddDepartment = false;
      this.$store.commit("SET_dialogcheck", false);
    },
    closedialogNew() {
      this.EditDepartment = false;
      // this.$store.commit("SET_dialogcheck", false);
    },
    // ;kdmvfkm
    async getdepartment() {
      this.overlay = true;
      var inputData = {
        method_name: "CORPONBOARD",
        page_no: 0,
        record_count: 0,
        page_size: 25,
        app_code: "CPORTAL",
        method_param: {
          action: "GDMASTER",
          searchtext: this.search,
          corp_id: this.$store.getters.get_corpid,
        },
      };
      var responseData = await apiCall(inputData);
      if (responseData.data.status == "00") {
        if (responseData.data.data != null || responseData.data.data != "") {
          this.getdepartmentlist = responseData.data.data;
        }
      } else if (responseData.data.status == "NOREC") {
        this.Nodata = responseData.data.status_msg;
        this.getdepartmentlist = [];
      }
      this.overlay = false;
      // console.log("depdata", this.getdepartmentlist);
    },
    preventLeadingSpace(e) {
      if (!e.target.value) e.preventDefault();
      else if (e.target.value[0] == " ")
        e.target.value = e.target.value.replace(/^\s*/, "");
    },
    Edit(item) {
      this.EditDepartment = true;
      // this.Name = item.name;
      this.EditName = item.department_name;
      this.EditDescr = item.department_description;
      this.DeptId = item.department_id;
    },
  },
};
</script>

<style>
.navbar {
  background: linear-gradient(to bottom, #2e4152 0%, #3c4d5d 50%, #202c37 100%);
}
</style>
